export enum Language {
  English = 'en',
  French = 'fr',
  Russian = 'ru',
}
